module.exports = __webpack_public_path__ + "img/clip_image120.19cf5b85.png";